import LinkBase from './LinkBase';
import Link from 'next/link';
import LinkWrapper from './LinkWrapper';

type Props = {
  label: string;
  href: string;
  size?: 'normal' | 'large';
  iconPosition?: 'left' | 'right';
  disabled?: boolean;
  isBreadcrumb?: boolean;
  bold?: boolean;
  onClick?: () => void;
};
const NextLink = ({ label, href, size, iconPosition, disabled, isBreadcrumb, bold = false, onClick }: Props) => {
  return (
    <LinkWrapper disabled={disabled}>
      <Link
        href={href}
        className={`outline-black-25 ${disabled ? 'pointer-events-none cursor-not-allowed' : ''}`}
        aria-disabled={disabled}
        onClick={onClick}
      >
        <LinkBase
          label={label}
          size={size}
          iconPosition={iconPosition}
          disabled={disabled}
          isBreadcrumb={isBreadcrumb}
          bold={bold}
        />
      </Link>
    </LinkWrapper>
  );
};
export default NextLink;
